export const cosignKeys = {
  base: ["cosign"] as const,
  supervisors: () => [...cosignKeys.base, "supervisors"] as const,
} as const;
